<app-public-page-template [headerText]="'Account recovery'">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-group form-row">
      <label for="email"><h3>Email Address:</h3></label>
      <div class="form-group input-group">
        <input [ngClass]="{ 'is-invalid': displayError(f.email) }"
          autocomplete="email"
          class="form-control"
          formControlName="email"
          id="email"
          placeholder=""
          type="text"/>
        @if (displayError(f.email)) {
          <div class="invalid-feedback">
            @if (f.email.errors) {
              <div>Valid email address required</div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-group form-row action-button-group">
      <button class="navy-btn col-5" type="submit">Send Password Reset Link</button>
      <button [routerLink]="routes.PUBLIC.LOGIN.path" class="navy-btn col-4" type="button">
        Cancel
      </button>
    </div>
  </form>
</app-public-page-template>